// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import animate from 'animate.css'
import '../static/css/common.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper.css'
Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false
Vue.use(animate)
Vue.use(ElementUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js